import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, AlertTriangle } from 'lucide-react';
import Button from '../components/Button';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-oro-bg flex items-center justify-center p-4">
      <div className="text-center max-w-md mx-auto">
        {/* 404 Icon */}
        <div className="bg-oro-surface border border-oro-border rounded-full w-24 h-24 flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-12 h-12 text-yellow-400" />
        </div>

        {/* Error Code */}
        <div className="mb-4">
          <h1 className="text-6xl font-bold text-accent mb-2">404</h1>
          <h2 className="text-xl font-semibold text-text-primary mb-2">
            Page Not Found
          </h2>
          <p className="text-text-muted">
            Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the wrong URL.
          </p>
        </div>

        {/* Suggestions */}
        <div className="bg-oro-surface border border-oro-border rounded-xl p-4 mb-6 text-left">
          <h3 className="font-medium text-text-primary mb-3">What you can try:</h3>
          <ul className="space-y-2 text-sm text-text-muted">
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-accent rounded-full"></div>
              Check the URL for any typos
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-accent rounded-full"></div>
              Go back to the previous page
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-accent rounded-full"></div>
              Start over from the homepage
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/')}
            variant="primary"
            size="lg"
            className="w-full"
          >
            <Home className="w-5 h-5 mr-2" />
            Go Home
          </Button>
          
          <Button
            onClick={() => window.history.back()}
            variant="secondary"
            size="lg"
            className="w-full"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Go Back
          </Button>
        </div>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-oro-border">
          <p className="text-xs text-text-muted">
            Need help? Contact our support team if you think this is an error.
          </p>
        </div>
      </div>
    </div>
  );
}